__turbopack_context__.v({
  "icon": "Quote-module-scss-module__A1VSXW__icon",
  "quote": "Quote-module-scss-module__A1VSXW__quote",
  "randomiseButton": "Quote-module-scss-module__A1VSXW__randomiseButton",
});
